import { CartItem } from "@/redux/slice/cart/types/CartItem";

export const getShipmentItemPrice = (shipmentItem: CartItem): number => {
  if (!shipmentItem) {
    return 0;
  }

  let sellingPrice: number;
  const mrp: number = shipmentItem.price;
  const specialPrice: string | number = shipmentItem.special_price;

  if (!specialPrice) {
    sellingPrice = mrp;
  } else if (typeof specialPrice === "string") {
    sellingPrice = (specialPrice ? Number(specialPrice) : mrp) || mrp;
  } else {
    sellingPrice = specialPrice;
  }

  return sellingPrice;
};
